import { TableRow, TableCell, Typography, Button } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import type { Squad } from '@/utils/squad'
import { toSquadLabel } from '@/utils/squad'
import { rowHeight } from '@/utils/table'

export type Props = {
  squad: Squad
  totalEscalations: number
  totalInventory: number
  totalAddedToInventory: number
  totalRemovedFromInventory: number
  totalMissedSLALastWorkingDay: number
  totalMissedSLATwoDaysInARow: number
  totalAutoPassed: number
}

const Row: FC<Props> = ({
  squad,
  totalEscalations,
  totalInventory,
  totalAddedToInventory,
  totalRemovedFromInventory,
  totalMissedSLALastWorkingDay,
  totalMissedSLATwoDaysInARow,
  totalAutoPassed,
}) => (
  <TableRow hover key={squad} sx={{ height: rowHeight }}>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        Squad {toSquadLabel(squad)}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {totalEscalations}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {totalInventory}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {totalAddedToInventory}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {totalRemovedFromInventory} ({totalAutoPassed} automatic)
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {totalMissedSLALastWorkingDay}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {totalMissedSLATwoDaysInARow}
      </Typography>
    </TableCell>
    <TableCell align="right" padding="none">
      <Button
        size="small"
        variant="text"
        component={Link}
        to={`/squad/${squad}`}
        sx={{ whitespace: 'noWrap' }}
      >
        View squad
      </Button>
    </TableCell>
  </TableRow>
)

export default Row
